import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profiles/new")({
  component: () => <div>Hello /_authenticated/profiles/new!</div>,
});
